import { Typography } from '@mui/material';
import { IApiColumnProps, IApiColumnType, IDocumentStatus } from '@tap/data-providers';
import { ChangeHistoryUserValue } from './ChangeHistoryUserValue';
import { TapPriorityList } from '../models';
import { BooleanValue } from './values/BooleanValue';
import { DateValue } from './values/DateValue';
import { JsonValue, JsonValueProps } from './values/JsonValue';
import { EnumValue, EnumValueProps } from './values/EnumValue';
import { AnyValue } from './values/AnyValue';
import { ChangeHistorySlotComponent } from './change-history.types';
import { dateTimeHelper } from '@tap/utils';

export type ColumnValueSlotProps = {
    enumValue?: Partial<EnumValueProps>,
    jsonValue?: Partial<JsonValueProps>,
}

type ChangeHistoryColumnValueProps = {
    value: any,
    columnInfo?: IApiColumnProps,
    slots?: ChangeHistorySlotComponent<ColumnValueSlotProps>,
    slotProps?: ColumnValueSlotProps,
}

export const ChangeHistoryColumnValue = ({ value, columnInfo, slots, slotProps }: ChangeHistoryColumnValueProps) => {
    if (!columnInfo?.type) {
        return <AnyValue value={value} />;
    }

    if (columnInfo.type === IApiColumnType.Boolean) {
        return <BooleanValue value={value} settings={columnInfo.boolProps} />;
    }

    if (columnInfo.type === IApiColumnType.Date) {
        return <DateValue value={value} settings={columnInfo.dateProps} />;
    }

    if (columnInfo.type === IApiColumnType.Json) {
        return <JsonValue {...(slotProps?.jsonValue ?? {})}
            value={value}
            settings={columnInfo.jsonProps} />;
    }

    if (columnInfo.type === IApiColumnType.Enum) {
        return <EnumValue {...(slotProps?.enumValue ?? {})}
            value={value}
            settings={columnInfo.enumProps} />;
    }

    if (value === undefined || value === null) {
        return (<Typography>-</Typography>);
    }

    if (columnInfo.type === 'ms') {
        return (<Typography>{dateTimeHelper.timeFormat(value)}</Typography>);
    }

    if (columnInfo.type === IApiColumnType.UserId) {
        return (<ChangeHistoryUserValue userId={value} />);
    }

    if (columnInfo.type === 'issueStatus') {
        const statusList = columnInfo.statusList || [];
        return (<Typography>{statusList.find((s: IDocumentStatus) => s.code === value)?.name || value}</Typography>);
    }

    if (columnInfo.type === 'priority') {
        return (<Typography>{TapPriorityList.find(p => p.code === value)?.name || value}</Typography>);
    }

    if (columnInfo.type === 'custom' && columnInfo.CustomComponent) {
        return (
            <columnInfo.CustomComponent
                fieldValue={value}
                {...(columnInfo.customComponentProps || {})} />
        );
    }


    return (<Typography>{value.toString()}</Typography>);
}